/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consumption_Slot_In_ProgressInputs */



/**
* | output |
* | --- |
* | "Interval in progress, still incomplete" |
*
* @param {Consumption_Slot_In_ProgressInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const consumption_slot_in_progress = /** @type {((inputs?: Consumption_Slot_In_ProgressInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumption_Slot_In_ProgressInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Interval in progress, still incomplete")
	return /** @type {LocalizedString} */ ("Intervalle en cours, encore incomplet")
});